import React from "react";
import TicketsTableHeader from "./components/TicketsTableHeader";
import TicketsTableBody from "./components/TicketsTableBody";
import TicketsPagination from "./components/TicketsPagination";
import { useTicketsTableSort } from "./hooks/useTicketsTableSort";

const TicketsTableDiff = ({
  headers,
  data,
  rowKey,
  defaultSortKey,
  tableClassName = "",
  headerClassName = "",
  rowClassName = "",
  tableActions,
  onRowClick,
  onPageChange,
  onPerPageChange,
  queries,
  tableStyle,
}) => {
  const { sortedData, sortConfig, handleSort } = useTicketsTableSort(
    data,
    defaultSortKey
  );

  const { dropdownIndex, toggleDropdown, handleActionClick } = tableActions;

  // Handle pagination actions
  const handleActionPerPage = (newPerPage) => {
    if (onPerPageChange) onPerPageChange(newPerPage);
  };

  const handleActionPage = (newPage) => {
    if (onPageChange) onPageChange(newPage);
  };

  return (
    <div className="w-full p-4 text-black font-Ubuntu">
      <div className="bg-white p-4 rounded-t-md shadow-lg">
        <table className={`w-full ${tableClassName}`}>
          <TicketsTableHeader
            headers={headers}
            sortConfig={sortConfig}
            onSort={handleSort}
            headerClassName={headerClassName}
            tableStyle={tableStyle}
          />
          <TicketsTableBody
            data={sortedData}
            headers={headers}
            rowKey={rowKey}
            dropdownIndex={dropdownIndex}
            toggleDropdown={toggleDropdown}
            onActionClick={handleActionClick}
            onRowClick={onRowClick}
            rowClassName={rowClassName}
            tableStyle={tableStyle}
          />
        </table>
      </div>

      <TicketsPagination
        queries={queries}
        onPageChange={handleActionPage}
        onPerPageChange={handleActionPerPage}
      />
    </div>
  );
};

export default TicketsTableDiff;
